import { AxiosRequest } from "_services/api";
import { HttpError } from "_services/api/HttpError";
import { HttpResponse } from "_services/api/HttpResponse";
import { IData, IHttpError } from "_services/api/interface/HttpResponse";
import { useEffect, useState } from "react";

export default function usePermissoes() {
  const api = AxiosRequest.makeApi();
  const [listaPermissoes, setListaPermissoes] = useState<any[]>([]);
  const [carregado, setCarregado] = useState<boolean>(false);
  const [erroPermissoes, setErroPermissoes] = useState<boolean>(false);

  const listarPermissoes = async () => {
    try {
      const { status, data } = await api.get("/autenticacao/permissoes");
      const rersponse = new HttpResponse(false, status, data);
      setListaPermissoes(data);
      setErroPermissoes(false);
      setCarregado(true);
      return rersponse;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setErroPermissoes(true);
      return response;
    }
  };

  const temPermissao = (nomeFuncionalidade: string): boolean =>
    Array.isArray(listaPermissoes) &&
    listaPermissoes.some(
      (item) => item.nome_funcionalidade === nomeFuncionalidade
    );

  useEffect(() => {
    if (!listaPermissoes.length) {
      listarPermissoes();
    }
  }, [listarPermissoes]);

  return { listaPermissoes, carregado, erroPermissoes, temPermissao };
}
